// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3XCsS","calendarButtons":"ClockData_calendarButtons__2IvHF"};